import React from "react"

const PageNotFound: React.FC = () => <h1>Page not found.</h1>

export default PageNotFound
